function parseBinding(binding) {
  const value = binding.value
  if (typeof value === 'number') {
    return { delay: value }
  }
  if (typeof value === 'object' && value !== null) {
    return {
      delay: value.delay || 0,
      direction: value.direction || 'up'
    }
  }
  return { delay: 0, direction: 'up' }
}

export default {
  inserted(el, binding) {
    const { delay, direction } = parseBinding(binding)
    el.classList.add('reveal-hidden', `reveal-${direction}`)
    if (delay) {
      el.style.transitionDelay = `${delay}ms`
    }

    if (typeof IntersectionObserver === 'undefined') {
      el.classList.add('reveal-visible')
      el.classList.remove('reveal-hidden')
      return
    }

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            el.classList.add('reveal-visible')
            el.classList.remove('reveal-hidden')
            observer.unobserve(el)
          }
        })
      },
      { threshold: 0.12, rootMargin: '0px 0px -48px 0px' }
    )

    observer.observe(el)
    el._revealObserver = observer
  },
  unbind(el) {
    if (el._revealObserver) {
      el._revealObserver.disconnect()
    }
  }
}
